// hooks/useTurnstile.js
import { useEffect, useRef, useCallback } from "react";

export function useTurnstile(sitekey, { onSuccess, onExpired, onError } = {}) {
  const turnstileRef = useRef(null);
  const widgetIdRef = useRef(null);

  const reset = useCallback(() => {
    if (window.turnstile && widgetIdRef.current != null) {
      window.turnstile.reset(widgetIdRef.current);
    }
  }, []);

  useEffect(() => {
    if (!sitekey) return;

    const render = () => {
      if (!turnstileRef.current || !window.turnstile) return;

      // Avoid double render
      if (widgetIdRef.current != null) return;

      widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
        sitekey,
        callback: (token) => onSuccess?.(token),
        "expired-callback": () => onExpired?.(),
        "error-callback": () => onError?.(),
      });
    };

    // If turnstile script already loaded
    if (window.turnstile) {
      render();
      return;
    }

    // Otherwise wait a bit (script is async)
    const interval = setInterval(() => {
      if (window.turnstile) {
        clearInterval(interval);
        render();
      }
    }, 50);

    return () => clearInterval(interval);
  }, [sitekey, onSuccess, onExpired, onError]);

  return { turnstileRef, reset };
}
